'use client';

import { useEffect, useState } from 'react';

export const useCurrentWidth = (): number => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    function handleResize(): void {
      const currentWidth = window.innerWidth;
      if (currentWidth !== width) {
        setWidth(window.innerWidth);
      }
    }
    window.addEventListener(`resize`, handleResize);

    handleResize();

    return (): void => window.removeEventListener(`resize`, handleResize);
  });

  return width;
};
